import { CarrierTypeNames } from '@pdqdev/pdq-shared/dist/CarrierData';
import { CARRIER_DISPLAY_NAMES } from './constants';

export const getCarrierTypeOptions = (): object[] => {
  const typesOptions: object[] = [];

  for (const typeKey in CarrierTypeNames) {
    if (!CarrierTypeNames[typeKey]) {
      continue;
    }

    const type = CarrierTypeNames[typeKey];
    if (!isDeprecatedCarrier(type)) {
      typesOptions.push({
        name: type,
        value: type,
        displayName: getCarrierDisplayName(type),
      });
    }
  }
  return typesOptions;
};

export function getCarrierDisplayName(carrierType: CarrierTypeNames): string {
  return CARRIER_DISPLAY_NAMES[carrierType] || carrierType;
}

function isDeprecatedCarrier(type: CarrierTypeNames) {
  if (type === CarrierTypeNames.IL_POST) {
    return true;
  }

  return false;
}
